var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 16,
      height: 16,
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.3335C6.68147 1.3335 5.39254 1.72448 4.29622 2.45703C3.19989 3.18957 2.34541 4.23078 1.84082 5.44895C1.33624 6.66713 1.20421 8.00756 1.46144 9.30077C1.71868 10.594 2.35361 11.7819 3.28596 12.7142C4.21831 13.6466 5.4062 14.2815 6.6994 14.5387C7.99261 14.796 9.33305 14.6639 10.5512 14.1593C11.7694 13.6548 12.8106 12.8003 13.5431 11.704C14.2757 10.6076 14.6667 9.31871 14.6667 8.00016C14.6667 6.23205 13.9643 4.53635 12.7141 3.28611C11.4638 2.03587 9.76812 1.3335 8.00001 1.3335ZM9.97532 8.7409H6.0247C5.82825 8.7409 5.63983 8.66287 5.50091 8.52395C5.362 8.38503 5.28396 8.19662 5.28396 8.00016C5.28396 7.80371 5.362 7.61529 5.50091 7.47638C5.63983 7.33746 5.82825 7.25942 6.0247 7.25942H9.97532C10.1718 7.25942 10.3602 7.33746 10.4991 7.47638C10.638 7.61529 10.7161 7.80371 10.7161 8.00016C10.7161 8.19662 10.638 8.38503 10.4991 8.52395C10.3602 8.66287 10.1718 8.7409 9.97532 8.7409Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDash);
export default __webpack_public_path__ + "static/media/red-dash.626e65676f6e7a70c0bbe2085e032525.svg";
export { ForwardRef as ReactComponent };